import { Link } from 'react-router-dom'

import { MarketPageHeader } from '../components/MarketPageHeader'
import { NotificationsFeed } from '../components/NotificationsFeed'

export const NotificationsScreen = () => (
  <section className="market-page market-page--notifications">
    <MarketPageHeader
      title="Обновления заявок"
      description="Изменения статусов от поставщиков. Ленту также можно открыть из колокольчика в шапке."
      actions={
        <Link to="/orders" className="echat-btn echat-btn--primary echat-btn--sm">
          К заявкам
        </Link>
      }
    />

    <p className="market-hint market-hint--compact">
      Push-уведомления в мессенджерах настраиваются в{' '}
      <Link to="/settings">настройках</Link> → «Каналы уведомлений».
    </p>

    <NotificationsFeed />
  </section>
)
